define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/comm/PostRequest",
	"csi/core/extendedPathService",
	"csi/xml"
], function(declare, _, PostRequest, {parseExtendedPath}, xml) {

	return declare(null, {
		// Array: values mapped from Merchandising hierarchy into Style/StyleAttributes.
		//  The format of each item is:
		//  {
		//      id: <id-of-attribute>,
		//      path: <path-in-the-extended-form>,
		//      value: <value-of-the-attribute>
		//  }
		//  This array contains items which are NOT used in the form.
		_mappedValues: null,

		setFormDefaultValues: function(/*csi.view.Widget*/view, /*Node*/merchProductVersions, /*Cache*/cache) {
			// summary: set form default values
			var defView = view.defView;

			var pv = cache.getNode(merchProductVersions[0]);

			var mp = cache.getNode(pv.__Parent__, true);

			view.addDefaultValue(xml.ATTR_NAME, mp.$Name);

			this._mappedValues = [];

			// evaluate Product Mapping expressions in the context of MerchProductVersion and assign default values according to results
			var request = new PostRequest("Merchandising", "EvaluateProductMappingAttributes")
				.addParameter("AddURLs", merchProductVersions);

			var self = this;

			return request.go().then(
				function(response) {
					// result node contains an attribute 'ProductAttributeMappingKeys' with all mapped attributes
					// and separate attributes with Ids from the list above
					var resultNodes = response.getResultNodes();
					var resultNode = response.getResultNode() || resultNodes[0];
					_.forEach(resultNode.ProductAttributeMappingKeys, function(key) {
						// for field name just use the name of the data point without the path
						var index = key.indexOf(":");
						if (index < 0)
							throw new Error("Incorrect key '" + key + "'in ProductAttributeMappingKeys. It must be in the form <id>:<extended-path>:0");

						var fieldName = key.substring(0, index);

						var field = defView.getField(fieldName);
						if (field) {
							view.addDefaultValue(fieldName, resultNode[key]);
							field.bDisableExpressionEvaluation = true;
							if (merchProductVersions.length > 1) {
								field.m_right = xml.RIGHT_NONE;
							}
						} else {
							var lastIndex = key.lastIndexOf(":");
							if (lastIndex < 0)
								throw new Error("Incorrect key '" + key + "'in ProductAttributeMappingKeys. It must be in the form <id>:<extended-path>:0");

							var path = key.substring(index + 1, lastIndex);

							var value = _.map(resultNodes, function(node) {
								return node[key];
							});

							var item = {
								id: fieldName,
								value: value,
								path: path
							};
							self._mappedValues.push(item);
						}
					});
					return response;
				},
				function(err) {
					throw err;
				}
			);
		},

		/**
		 * @param {Controller} controller - The form's action
		 * @param {string[]} styleUrls - The styles URLs that we need to apply the form's fields' values on.
		 * @param {Number} styleCandidateQty - number of styles. We can't rely on styleUrls.length because
		 * 		if we have 2 products and styleCandidateQty on the form is 2, then styleUrls length would be 4.
		 */
		_applyFormFieldsOnStyles: function(controller, styleUrls, styleCandidateQty) {
			var fd = controller.getFormData();

			_.each(fd.getFields(), function(field) {
				var control = field.m_control;

				if ((control && control.disabled) ||
					(!field.isUpdated() && xml.isEmptyURL(field.m_control.displayedValue) && xml.isEmptyURL(field.m_control.value))) {
					// if field is disabled, don't add it to changeNode request
					field.m_bUsed = true;
				}
			});

			var productCounter;
			_.each(styleUrls, function(urlStyle, index) {
				// Add the fields on the form, like custom attributes
				controller.toWriterFields(urlStyle);

				productCounter = Math.floor(index / styleCandidateQty);

				this.changeMappedValues(controller.m_writer, urlStyle, productCounter);
			}, this);

			_.each(styleUrls, function(urlStyle) {
				// We need to validate all the styles at the end, so we need a separate loop for that.
				controller.m_writer.validateNode(urlStyle, true);
			});
		},

		changeMappedValues: function(/*Writer*/writer, /*URL*/urlStyle, /*Number*/ index) {
			// summary: add mapped values to the style
			_.each(this._mappedValues, function(item) {
				var ep = parseExtendedPath(item.path);
				var rc = ep.getEndClass();
				var ra = rc.getAttribute(item.id, true, false, true);

				// get the type of attribute
				var attrType = ra.getType();

				// change the node at the path
				writer.changeNode(xml.getUrlPath(urlStyle, ep.getStandardPath())).changeAttribute(item.id, attrType, item.value[index]);
			});
		}
	});
});